<template>
<div class="r fc" style="flex:1;backgroundColor:#fff;height:100vh;width:100vw">
  <h6 style=" color:#dddd;"></h6>
  <template v-if="!iframe">
    <img :src="$store.state.usr.brand?.logo" style="max-width:60vw;max-height:15vh"/>
    
    

    <h3 :style="{ marginBottom:'40px' }">{{$authToken.deviceName}}</h3>
    <template  v-if="device?.favorites" >
      <template v-for="(i,idInformativa) in device.favorites" :key="idInformativa">
          <div style="max-width:800px; width:90%;margin:16px auto" v-if="$store.state.usr.informative[idInformativa] && !$store.state.usr.informative[idInformativa].archived" >
          <q-btn class="r fc q-py-md" style="" size="lg" @click="openInformativaFavorites(idInformativa)" >
            {{$store.state.usr.informative[idInformativa]?.name}}
          </q-btn>
        </div>
      </template>
    </template>
  <img v-if="device?.photo" :src="device.photo" style="max-width:60vw;max-height:15vh;margin:20px 0"/>
  </template>
  <template v-else>
    <iframe style="border:none;height:100vh;width:100vw" :src="iframe"/>
  </template>
</div>  
</template>

<script >

export default {
  name: 'DevicePage',
  computed:{
    device(){
      return this.$store.state.usr.devices?.[this.$authToken.deviceName];
    }
  },
  data:()=>({ 
    isLoading:false,
    iframe:''
  }),
  methods:{
    openInformativaFavorites(idInformativa){
      /* this.$socket.emit('openInformativaFavorites',idInformativa,(err,data)=>{

      }) */
      let i = this.device?.favorites?.[idInformativa];
      this.iframe=  `https://gdpr.privacyready.it/informativa/${idInformativa}/${i.formId}/PrivacyReady.html`
    }
  },
  mounted(){

    this.$socket.subscribe(`device/${this.$authToken.customData?.org?._id||this.$authToken._id }/${this.$authToken.deviceName}`).watch(data=>{
      console.log('data',data);

      switch (data.action) {
        case 'open' : {
          if (data.iframe && data.url !='/')
            this.iframe = data.url;
          else 
            window.location.href = data.url;

          break;
        }
        case 'close' : {
          window.location.reload();
          break;
        }
      }
    });
  },
}
</script>

<style lang="scss" scoped>


</style>
